<template>
    <div class='layer-pop notice-pop'>
        <div class='view-content'>
            <div class='top-area'>
                <span class='title'>{{ title }}</span>
                <button class='close-btn' @click='onClickBtnCancel'></button>
            </div>

            <div class='view-area'>
                <!-- 이미지 일시 -->
                <img :src='imgUrl' alt='' @click='onClickImage'>
                <!-- //이미지 일시 -->
            </div>
            <div class='bottom-area-pop'>
                <div class='daily-check'>
                    <button class='check-btn' @click='onClickStopShowToday'>오늘 그만보기</button>
                    <button class='close' @click='onClickBtnCancel'>닫기</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'popup',
    props: {
        imageUrl: {
            type: String,
        },
        title: {
            type: String,
        },
        imgUrl: {
            type: String,
        },
        url: {
            type: String,
        },
    },
    data() {
        return {
            isPop: false,
        };
    },
    methods: {
        onClickBtnCancel() {
            this.$emit('close-popup');
        },
        onClickStopShowToday() {
            this.$emit('stop-show-today');
        },
        onClickImage() {
            if (this.url) {
                location.href = this.url;
            }
        },
    },

};
</script>

<style scoped>

</style>
